angular.module('dnecom')
    .controller('StoreBadgesSettingsController', ["$scope", "StoreUtils", "IntegrationsUtils", "notifications", "$http", function ($scope, StoreUtils, IntegrationsUtils, notifications, $http) {
        $scope.isMcafeeEnabled = TemplateData.value('isMcafeeEnabled');

        $scope.accounts = [];
        $scope.noAccounts = true;

        IntegrationsUtils.getAccountsByTypes(function (accounts) {
            $scope.accounts = accounts;
            $scope.noAccounts = _.isEmpty($scope.accounts);
        });

        $scope.setDefaultValues = function () {
            if (!$scope.store.properties.badges.customScriptAlign) {
                $scope.store.properties.badges.customScriptAlign = 'right';
            }
            if (!$scope.store.properties.badges.customScriptAppearance) {
                $scope.store.properties.badges.customScriptAppearance = 'checkout'
            }
        }
        $scope.enableMcAfeeIntegration = function () {
            if ($scope.store.properties.integrations === undefined) {
                $scope.store.properties.integrations = {};
            }

            if ($scope.store.properties.badges.mcafeeCartAndCheckout == 1 || $scope.store.properties.badges.mcafeeAllPages == 1) {
                $scope.store.properties.badges.mcafeeEnabled = 1;
            } else {
                $scope.store.properties.badges.mcafeeEnabled = 0;
                $scope.store.properties.badges.mcafeeMobileEnabled = 0;
            }
        };

        $scope.$on('store.settings.saved', function(event) {
            if (
                !$scope.store.properties
                || !$scope.store.properties.badges
                || !$scope.store.properties.badges.mcafeeEnabled
                || $scope.store.properties.badges.mcafeeSecured == 1
                || !$scope.isMcafeeEnabled
            ) {
                return;
            }

            $http.post(Routing.generate('integrations_mcafee_add_site', {
                id: $scope.store.id
            })).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Unknown error.');
                    return;
                }
                $scope.store.properties.badges.mcafeeSiteId = response.data.siteId;
                $scope.store.properties.badges.mcafeeSecured = '1';
                notifications.success(response.data.message);
            }, function(response) {
                if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                    var errors = [];
                    for (var key in response.data.errors) {
                        errors.push(response.data.errors[key]);
                    }
                    notifications.danger(errors.join(', '));
                } else {
                    notifications.danger('Request error.');
                }
            });
        });
    }]);
